/* eslint-disable */
function createStorage (type) {
  function set (key, value) {
    if (key === undefined || value === undefined) {
      console.warn('Key and value can\'t be undefined')
      return
    }

    value = JSON.stringify(value)
    window[ type + 'Storage' ].setItem(key, value)
  }

  function get (key) {
    if (!key) return

    const value = window[ type + 'Storage' ].getItem(key)
    try {
      return JSON.parse(value)
    } catch (e) {
      return value
    }
  }

  function remove (key) {
    if (!key) return
    window[ type + 'Storage' ].removeItem(key)
  }

  return Object.freeze({
    set, get, remove
  })
}

export const ls = createStorage('local')
export const ss = createStorage('session')
